import { render } from "./McrAttachmentDialog.vue?vue&type=template&id=1b490648&scoped=true"
import script from "./McrAttachmentDialog.vue?vue&type=script&lang=js"
export * from "./McrAttachmentDialog.vue?vue&type=script&lang=js"

import "./McrAttachmentDialog.vue?vue&type=style&index=0&id=1b490648&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b490648"]])

export default __exports__